/**
 * Returns true if value is of the same type as T
 * @param value
 * @param keys 
 * @returns 
 */
export function isType<T>(value: unknown, keys?: (keyof T)[]): value is T {
    if (!value || Array.isArray(value) || typeof value !== "object") {
      return false;
    }

    // If `keys` is defined, we check these keys, otherwise we take all the keys of the object
    const requiredKeys = keys ?? (Object.keys(value) as (keyof T)[]);
    
    return requiredKeys.every(key => key in value);
}